export const SIZE_LABELS = [ 'Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB' ];

export const MAX_FILE_SIZE_TO_UPLOAD = 52428800; // 50 Mbs

export const MAX_ROWS_IN_SEARCH_FILE_SELECT = 10;
